<template>
    <div class="flex flex-col items-center">
        <transition mode="out-in">
            <QuestionInputs
                v-if="!interruptionShow && primaryActive"
                :title="$root.data.questionTextBeauty"
                :values="$root.config.quiz.beauty"
                :flex-config="{desktop: {cols: 2, gap: '1.25rem', maxWidth: '54.375rem', tall: true}}"
                @value-changed="value => $root.config.quiz.beauty.find(answer => answer.id === value).secondary ? handleSecondary(value) : handleNext(value)"
            />
            <QuestionInputs
                v-else-if="!interruptionShow && secondaryActive"
                :title="secondaryTitle"
                :part-text="`${$root.config.translations.misc.part} 2 ${$root.config.translations.misc.of} 2`"
                :values="secondaryValues"
                :flex-config="{desktop: {maxWidth: '32.625rem'}}"
                @value-changed="value => handleNext(value)"
            />
            <Interruption
                v-else-if="interruptionContent && interruptionShow"
                :config="{content: interruptionContent}"
                @goToNext="goToNext"
            />
        </transition>
    </div>
</template>

<script>
    import QuestionInputs from '@/apps/quiz/components/QuestionInputs.vue';
    import Interruption from '@/apps/quiz/components/Interruption.vue';

    export default {
        components: {
            QuestionInputs,
            Interruption
        },
        data() {
            return {
                primaryActive: true,
                secondaryActive: false,
                secondaryTitle: null,
                secondaryValues: null,
                interruptionShow: false,
                interruptionInstance: null,
                interruptionContent: null,
                value: []
            };
        },
        methods: {
            handleSecondary (value) {
                this.secondaryTitle = this.$root.config.quiz.beauty.find(answer => answer.id === value).secondary.question;
                this.secondaryValues = this.$root.config.quiz.beauty.find(answer => answer.id === value).secondary.answers;

                this.value = [value];

                setTimeout(() => {
                    this.primaryActive = false;
                    this.secondaryActive = true;
                    this.$root.config.navigation.secondary = true;
                    window.innerWidth < 1024 ? window.scrollTo(0, 0) : document.querySelector('.js-route-content-container').scrollTo(0, 0);
                }, 300);
            },
            handleNext (value) {
                this.value.push(value);
                this.interruptionInstance = this.$root.config.quiz.beauty.find(answer => answer.id === this.value[0]).interruption;

                if (this.interruptionInstance !== 'undefined' || this.interruptionInstance !== null) {
                    this.interruptionContent = this.interruptionInstance;
                }

                setTimeout(() => {
                    if (this.interruptionContent) {
                        this.interruptionShow = true;
                        window.innerWidth < 1024 ? window.scrollTo(0, 0) : document.querySelector('.js-route-content-container').scrollTo(0, 0);
                    } else {
                        this.goToNext();                        
                    }
                    this.$root.config.navigation.secondary = false;
                }, 300);
            },
            goToNext () {
                this.$router.push({
                    name: 'Supplements',
                    params: {
                        beauty: this.value.join(',')
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .v-enter-active,
    .v-leave-active {
        transition: all 0.3s ease-out;
    }

    .v-enter-from,
    .v-leave-to {
        @apply opacity-0;
    }
</style>
